import React from "react";
import { Box } from "@mui/material";

// Placeholder view: blank content, but overrides the app's default lavender background with white
const BaseWrapper = ({ children }) => <Box>{children}</Box>;

export default BaseWrapper;
